import DZModelPage from "@/model/DZModelPage";

class DZSearchAgentUser extends DZModelPage{

    /**
     * 审核状态：0-未审核，1-审核通过，2-审核未通过
     */
    status = "";
    /**
     * 代理城市
     */
    cityId = "";

    countyArr = [];

    level = ""
    /**
     * 姓名
     */
    name = "";
    /**
     * 代理开始时间
     */
    startTime = "";
    /**
     * 代理结束时间
     */
    endTime = "";

    phone = "";

    email = "";

    wxNum = "";
}
export default DZSearchAgentUser
